jQuery(document).ready(function ($) {
    $('form.sib_signup_form').on('submit', function (e) {
        $(this).find(":submit").attr('disabled', 'disabled');
    });
});
